// @flow
import TagsField from './TagsField'

export default TagsField
